import React from 'react';

const Footer = () => (
  <div className="Footer">
    <p>This site brought to you by <a href="https://zerobased.co">zerobased.co</a></p>
  </div>
);

export default Footer;
